import { Col, Row } from '@/app/components/Flex/Flex'
import { Layout } from '@/app/components/Layout/Layout'
import { MenuFooter } from '@/app/components/MenuFooter/MenuFooter'
import { Motion } from '@/app/components/Motion/Motion'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import { useMedia } from '@/app/hooks/useMedia'
import { useNavigate, useNavigateSearchParams } from '@/app/hooks/useNavigate'
// import matrixMoneyPng from '@/app/img/layout/matrix-money.png'
import matrixPng from '@/app/img/layout/matrix.png'
import moonPng from '@/app/img/layout/moon.png'
import natalPng from '@/app/img/layout/natal.png'
import synastryJpg from '@/app/img/layout/synastry.jpg'
// import topicsPng from '@/app/img/layout/topics.png'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import styles from './index.module.scss'

export const ToolsPage: FunctionalComponent = () => {
  const [params, navigate] = useNavigateSearchParams()
  const route = useNavigate()
  const isMobile = useMedia(1023)

  useLayoutEffect(() => {
    const redirect = params.get('redirect')

    if (redirect) {
      if (isMobile) {
        navigate((prev) => {
          const next = new URLSearchParams(prev)
          next.delete('redirect')
          return next
        }, {
          replace: true,
        })

        route(redirect)
      }
      else {
        route(redirect, { replace: true })
      }
    }
    else if (!isMobile) {
      route('~/tools/natal', { replace: true })
    }
  }, [isMobile])

  return (
    <Layout>
      <Layout.Content>
        <Layout.HeadMenu />

        <Row gap={15} flexGrow={1}>
          <Motion>
            <Row gap={30}>
              <Row gap={10}>
                <UI.Panel
                  hover
                  radius='l'
                  link='~/tools/natal'
                >
                  <Col gap={15} alignItems='center'>
                    <img class={styles.icon} src={natalPng} alt='' />

                    <Row gap={4}>
                      <Text fontWeight={600} fontSize={18}>
                        Натальная карта
                      </Text>
                      <Text fontSize={14} opacity={0.5}>
                        Кто ты и как устроен
                      </Text>
                    </Row>
                  </Col>
                </UI.Panel>

                <UI.Panel
                  hover
                  radius='l'
                  link='~/tools/matrix'
                >
                  <Col gap={15} alignItems='center'>
                    <img class={styles.icon} src={matrixPng} alt='' />

                    <Row gap={4}>
                      <Text fontWeight={600} fontSize={18}>
                        Матрица судьбы
                      </Text>
                      <Text fontSize={14} opacity={0.5}>
                        Предназначение и сильные стороны
                      </Text>
                    </Row>
                  </Col>
                </UI.Panel>

                <UI.Panel
                  hover
                  radius='l'
                  link='~/tools/synastry'
                >
                  <Col gap={15} alignItems='center'>
                    <img class={classNames(styles.icon, styles.synastry)} src={synastryJpg} alt='' />

                    <Row gap={4}>
                      <Text fontWeight={600} fontSize={18}>
                        Совместимость
                      </Text>
                      <Text fontSize={14} opacity={0.5}>
                        Разбор вашей пары
                      </Text>
                    </Row>
                  </Col>
                </UI.Panel>

                <UI.Panel
                  hover
                  radius='l'
                  link='~/moon'
                >
                  <Col gap={15} alignItems='center'>
                    <img src={moonPng} alt='' class={classNames(styles.icon, styles.moon)} />

                    <Row gap={4}>
                      <Text fontWeight={600} fontSize={18}>
                        Луна
                      </Text>
                      <Text fontSize={14} opacity={0.5}>
                        Лунный календарь
                      </Text>
                    </Row>
                  </Col>
                </UI.Panel>
              </Row>

              {
                /* <UI.Panel
                  hover
                  radius='l'
                  link='~/topics'
                >
                  <Col gap={15} alignItems='center'>
                    <span class={classNames(styles.icon, styles.topics)}>
                      <img src={topicsPng} alt='' />
                    </span>

                    <Row gap={4}>
                      <Text fontWeight={600} fontSize={18}>
                        Темы
                      </Text>
                      <Text fontSize={14} opacity={0.5}>
                        Полезные штуки по астрологии, таро и матрице
                      </Text>
                    </Row>
                  </Col>
                </UI.Panel>
              </Row> */
              }

              {
                /* <Row gap={10}>
                <Text
                  upper
                  fontSize={12}
                  opacity={0.5}
                  class={styles.subHeader}
                >
                  Темы
                </Text>

                <UI.Panel
                  hover
                  radius='l'
                  link='~/tools/matrix-money'
                >
                  <Col gap={10} alignItems='center'>
                    <img class={classNames(styles.icon, styles.small)} src={matrixMoneyPng} alt='' />

                    <Row gap={4}>
                      <Text fontWeight={600} fontSize={18}>
                        Денежный канал
                      </Text>
                      <Text fontSize={14} opacity={0.5}>
                        Матрица судьбы
                      </Text>
                    </Row>
                  </Col>
                </UI.Panel>
              </Row> */
              }
            </Row>
          </Motion>
        </Row>

        <MenuFooter />
      </Layout.Content>

      {
        /* <Page.Wrapper>
        <Page>
          <Page.Body>
            <Page.List>
              <Motion>
              </Motion>

              <Motion>
              </Motion>

              {hasMatrixYearAccess && (
                <Motion>
                  <Block
                    radius='l'
                    padding='l'
                    onClick={() => {
                      route('~/tools/forecast/matrix')
                    }}
                  >
                    <Flex dir='row' gap={15} align='center'>
                      <img
                        class={styles.icon}
                        src={mapMonthImg((new Date()).getMonth() + 1)}
                        alt=''
                      />
                      <Flex gap={4}>
                        <Typo size='xl' strong>
                          Год по матрице
                        </Typo>
                        <Typo size='m' color='black2'>
                          Главные темы года
                        </Typo>
                      </Flex>
                    </Flex>
                  </Block>
                </Motion>
              )}

              <Motion>
              </Motion>
            </Page.List>

            <MenuFooter />
          </Page.Body>
        </Page>
      </Page.Wrapper> */
      }
    </Layout>
  )
}
